<template>
  <div id="tryout-form">
    <ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{ path: '/' }">Home</router-link>
      </li>
      <li class="active">Pengaturan Iklan</li>
    </ol>
    <h1 class="page-header">Pengaturan Iklan</h1>
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Form Pengaturan</h4>
          </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-md-6">
                <h4>General</h4>
                <div class="form-horizontal">
                  <div class="form-group">
                    <label class="col-md-4 control-label" style="">Status Ads</label>
                    <div class="col-md-8 col-xs-12">
                      <div class="btn-group btn-toggle">
                        <button
                          @click="adsStatus = true"
                          :class="
                            adsStatus
                              ? 'btn btn-xs btn-success active'
                              : 'btn btn-xs btn-default'
                          "
                        >
                          ON
                        </button>
                        <button
                          @click="adsStatus = false"
                          :class="
                            !adsStatus
                              ? 'btn btn-xs btn-danger active'
                              : 'btn btn-xs btn-default'
                          "
                        >
                          OFF
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-md-4 control-label" style="padding-top: 18px"
                      >Trigger Ads</label
                    >
                    <div class="col-md-3 col-xs-4">
                      <div>
                        Minimum Soal
                        <input
                          type="number"
                          class="form-control"
                          min="0"
                          v-model="minQ"
                        />
                      </div>
                      <div style="margin-top: 20px">
                        Maximum Soal
                        <input
                          type="number"
                          class="form-control"
                          min="0"
                          v-model="maxQ"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <h4>Google Ads</h4>
                <div class="form-horizontal">
                  <div class="form-group">
                    <label class="col-md-4 control-label">Target Kelas</label>
                    <div class="col-md-3 col-xs-4">
                      <div>
                        <button
                          class="btn btn-selecting dropdown-toggle"
                          type="button"
                          id="dropdownMenu2"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          style="
                            padding: 10px;
                            display: flex;
                            align-items: center;
                            background: white;
                            border: solid 1px lightgray;
                          "
                        >
                          <div style="margin-right: 10px">Pilih Kelas</div>
                          <div
                            v-if="googleTargeted.length > 0"
                            style="display: flex; flex-flow: wrap"
                          >
                            <span
                              v-for="(item, i) in googleTargeted"
                              :key="item + 'a'"
                              @click.prevent="googleTargeted.splice(i, 1)"
                              style="
                                color: white;
                                border-radius: 4px;
                                padding: 5px;
                                background: gray;
                                border: gray solid 1px;
                                margin: 4px;
                              "
                            >
                              Kelas {{ item }} <i class="fa fa-close"></i
                            ></span>
                          </div>

                          <!-- {{ googleTargeted.length > 0 ? googleTargeted : "Pilih Kelas" }} -->
                          <span class="caret" v-if="googleTargeted.length == 0"></span>
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                          <div
                            v-for="item in listKelas"
                            :key="item"
                            @click="googleTargeted.push(item)"
                          >
                            <li
                              style="padding: 10px"
                              v-if="hideClass(item, googleTargeted)"
                            >
                              <a>Kelas {{ item }}</a>
                            </li>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-md-12"
              style="display: flex; align-items: center; justify-content: center"
            >
              <div style="background: white; display: flex; flex-flow: column">
                <span style="color: white; font-weight: bold; margin: 10px"
                  >Tekan untuk menyimpan semua perubahan data!</span
                >
                <button @click="saveData()" class="btn btn-success btn-large">
                  Simpan
                </button>
              </div>
            </div>
            <h4>Internal Ads</h4>
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-2"><h5>Kelas</h5></div>
                <div class="col-md-3"><h5>Judul</h5></div>
                <div class="col-md-3"><h5>Deskripsi</h5></div>
                <div class="col-md-2"><h5>Image</h5></div>
                <div class="col-md-2"></div>
              </div>
              <div
                class="row"
                style="padding: 10px 0px 10px 0px; border-bottom: 1px solid lightgray"
                v-for="(d, i) in mInternalAdsData"
                :key="i"
              >
                <div class="col-md-2">
                  <div>
                    <button
                      class="btn btn-selecting dropdown-toggle"
                      type="button"
                      id="dropdownMenu2"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style="
                        padding: 10px;
                        display: flex;
                        align-items: center;
                        background: white;
                        border: solid 1px lightgray;
                        flex-flow: column;
                      "
                    >
                      <div style="margin-right: 10px">Pilih Kelas</div>
                      <div
                        v-if="d.grades.length > 0"
                        style="display: flex; flex-wrap: wrap"
                      >
                        <button
                          v-for="(item, it) in d.grades"
                          :key="item + 'a'"
                          @click.prevent="removeGrade(i, it)"
                          style="
                            color: white;
                            border-radius: 4px;
                            padding: 5px;
                            background: gray;
                            border: gray solid 1px;
                            margin: 4px;
                          "
                        >
                          Kelas {{ item }} <i class="fa fa-close"></i>
                        </button>
                      </div>
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                      <div
                        v-for="item in listKelas"
                        :key="item"
                        @click="addGrade(i, item)"
                      >
                        <li
                          style="padding: 10px"
                          v-if="hideClass(item, internalSelectedClass)"
                        >
                          <a>Kelas {{ item }}</a>
                        </li>
                      </div>
                    </ul>
                  </div>
                </div>
                <div class="col-md-3">
                  <textarea
                    v-model="d.title"
                    maxlength="220"
                    class="form-control"
                    cols="30"
                    rows="5"
                  />
                </div>
                <div class="col-md-3">
                  <textarea
                    v-model="d.description"
                    class="form-control"
                    id=""
                    cols="30"
                    rows="5"
                  >
                  </textarea>
                </div>
                <div
                  class="col-md-2"
                  style="display: flex; flex-flow: column; justify-content: center"
                >
                  <input
                    id="fileUpload"
                    type="file"
                    hidden
                    @change="onFileChange"
                    accept="image/*"
                  />
                  <button
                    type="button"
                    class="btn btn-warning"
                    v-if="d.image == ''"
                    @click="chooseFiles(d, i)"
                  >
                    Pilih Gambar <i class="fa fa-image"></i>
                  </button>
                  <img
                    :src="d.image + '?rnd=' + Math.random(1231231)"
                    v-if="d.image !== ''"
                    style="height: 100px"
                  />
                  <button
                    class="btn btn-info btn-xs"
                    v-if="d.image !== ''"
                    @click="mInternalAdsData[i].image = ''"
                    style="margin-top: 10px"
                  >
                    <i class="fa fa-pencil"></i>
                  </button>
                </div>
                <div
                  class="col-md-2"
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-flow: row;
                  "
                >
                  <button
                    @click="saveInternalSetting(d, i)"
                    class="btn btn-success btn-xl"
                    style="margin-right: 10px"
                  >
                    <i class="fa fa-save"></i>
                  </button>
                  <button
                    class="btn btn-danger btn-xl"
                    v-if="i + 1 !== mInternalAdsData.length"
                    @click="deleteAds(d.id)"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                  <!-- <button
                    class="btn btn-success btn-xl"
                    v-if="i + 1 === mInternalAdsData.length"
                    @click="addRow()"
                  >
                    <i class="fa fa-plus"></i>
                  </button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
    <p id="msg"></p>
  </div>
</template>
<script>
import Spinner from "@/components/plugins/Spinner";
import AdsService from "@/services/ads.js";
import FileService from "@/services/file.js";
export default {
  name: "form-iklan",
  components: {
    "app-spinner": Spinner,
  },
  data: function () {
    return {
      step: 1,
      adsStatus: true,
      showSave: false,
      googleTargeted: [],
      minQ: 0,
      maxQ: 0,
      listKelas: [4, 5, 6, 7, 8, 9, 10, 11, 12],
      internalSelectedClass: [],
      mInternalAdsData: [
        {
          grades: [],
          title: "",
          description: "",
          image: "",
        },
      ],
      isLoading: false,
      url: "",
      selectedUploadRow: "",
      file: "",
      indexSelectedUploadRow: null,
    };
  },
  watch: {
    mInternalAdsData: {
      // This will let Vue know to look inside the array
      deep: true,
      // We have to move our method to a handler field
      handler: function (val, oldVal) {
        var context = this;
        context.revalidateGrades();
        // context.showSave = true;
      },
    },
  },
  mounted() {
    this.getGeneralSetting();
    this.getInternalSetting();
  },
  methods: {
    addRow() {
      var datas = this.mInternalAdsData[this.mInternalAdsData.length - 1];
      if (
        datas.grades.length != 0 &&
        datas.title !== "" &&
        datas.description !== "" &&
        datas.image !== ""
      ) {
        this.mInternalAdsData.push({
          grades: [],
          title: "",
          description: "",
          image: "",
        });
      } else {
        alert("Data row ini tidak lengkap");
      }
    },
    hideClass(v, arr) {
      var a = arr.find((el) => {
        return el === v;
      });
      if (a) return false;
      else return true;
    },
    getGeneralSetting() {
      var context = this;
      AdsService.getGeneralAds(function (result) {
        context.isLoading = false;
        if (result.success) {
          var res = result.data;
          context.googleTargeted = res.google_ads_targets;
          context.adsStatus = res.is_ads_active;
          context.minQ = res.minimum_test_range;
          context.maxQ = res.maximum_test_range;
        }
      });
    },
    revalidateGrades() {
      var context = this;
      var merged = [];
      for (let i = 0; i < context.mInternalAdsData.length; i++) {
        merged.push(...context.mInternalAdsData[i].grades);
      }
      context.internalSelectedClass = merged;
    },
    removeGrade(i, ig) {
      this.mInternalAdsData[i].grades.splice(ig, 1);
      if (this.mInternalAdsData[i].id)
        this.saveInternalSetting(this.mInternalAdsData[i], i);
      this.$forceUpdate();
    },
    addGrade(i, g) {
      this.mInternalAdsData[i].grades.push(g);
      if (this.mInternalAdsData[i].id)
        this.saveInternalSetting(this.mInternalAdsData[i], i);
    },
    getInternalSetting() {
      var context = this;
      AdsService.getInternalAds(function (result) {
        context.isLoading = false;
        if (result.success) {
          var re = result.data;
          context.mInternalAdsData = re;
          context.revalidateGrades();
          context.mInternalAdsData.push({
            grades: [],
            title: "",
            description: "",
            image: "",
          });
        }
      });
    },
    saveData() {
      if (
        this.minQ > this.maxQ ||
        this.minQ < 1 ||
        this.maxQ < 1 ||
        this.minQ === "" ||
        this.maxQ === ""
      ) {
        alert("Trigger Ads tidak valid");
        return false;
      } else {
        this.updateGeneralSetting();
      }
    },
    updateGeneralSetting() {
      var body = {
        is_ads_active: this.adsStatus,
        minimum_test_range: this.minQ,
        maximum_test_range: this.maxQ,
        google_ads_targets: this.googleTargeted,
      };
      AdsService.saveGeneralAdsSetting(body, function (result) {
        console.log(result);
        if (result.success) {
          alert("Data general ads berhasil di simpan");
        }
      });
    },
    saveInternalSetting(bod, i) {
      var context = this;
      if (context.indexSelectedUploadRow !== null) {
        bod.image = context.mInternalAdsData[i].image;
      }

      if (bod.title.length > 225) {
        alert("judul terlalu panjang");
        return false;
      }
      if (
        bod.grades.length != 0 &&
        bod.title !== "" &&
        bod.description !== "" &&
        bod.image !== ""
      ) {
        if (bod.id) {
          AdsService.updateInternalAdsSetting(bod, function (result) {
            console.log(result);
            if (result.success) {
              alert("Data internal ads berhasil di ubah");
              context.indexSelectedUploadRow = null;
              context.getInternalSetting();
              context.$forceUpdate();
            }
          });
        } else {
          AdsService.saveInternalAdsSetting(bod, function (result) {
            console.log(result);
            if (result.success) {
              alert("Data internal ads berhasil di simpan");
              context.indexSelectedUploadRow = null;
              context.getInternalSetting();
              context.$forceUpdate();
            }
          });
        }
      } else {
        alert("Data Belum lengkap");
      }
    },
    deleteAds(i) {
      var context = this;
      var txt;
      if (confirm("Apa kamu yakin menghapus iklan ini?")) {
        AdsService.deleteInternalAds(i, function (result) {
          console.log(result);
          if (result.success) {
            alert("Ads berhasil di hapus");
            context.getInternalSetting();
            context.$forceUpdate();
          }
        });
      } else {
        txt = "berhasil di batalkan!";
      }
      document.getElementById("msg").innerHTML = txt;
    },
    chooseFiles(d, i) {
      this.selectedUploadRow = d;
      this.indexSelectedUploadRow = i;
      document.getElementById("fileUpload").click();
    },
    onFileChange(e) {
      const file = e.target.files[0];
      const fileType = file["type"];
      const validImageTypes = [
        "image/gif",
        "image/jpeg",
        "image/png",
        "image/svg+xml",
        "image/gif",
      ];
      if (!validImageTypes.includes(fileType)) {
        alert("file type not valid");
      } else {
        let _this = this;
        let fileObj = file;
        let reader = new FileReader();
        reader.readAsDataURL(fileObj);
        reader.onload = function (e) {
          let image = new Image();
          image.src = e.target.result;
          image.onload = function () {
            _this.url = URL.createObjectURL(fileObj);
            _this.file = fileObj;
            _this.uploadPicture(_this.file);
          };
        };
      }
    },
    uploadPicture(item) {
      var path = "sales/internal_ads/" + Date.now() + ".jpg";
      var context = this;
      var imageData = item;
      this.isLoading = true;
      FileService.upload(imageData, path, function (response) {
        console.log(JSON.stringify(response));
        if (response.success) {
          var imageUrl =
            "https://" +
            process.env.OSS_BUCKET_NAME +
            "." +
            process.env.OSS_ENDPOINT +
            "/" +
            response.data;
          context.selectedUploadRow.image = imageUrl;
          context.mInternalAdsData[context.indexSelectedUploadRow].image = imageUrl;
          context.isLoading = false;
          context.$forceUpdate();
        } else {
          context.isLoading = false;
          alert(
            "Gagal Upload gambar, periksa kembali size gambar (max: 2mb) atau type file yang diupload"
          );
          context.getInternalSetting();
          context.$forceUpdate();
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Form.vue?7963d64c